$(document).ready(function(){
  if (window.screen.width >= 1024) {
    const images = $('.product-single__photos .image-container img');


    $(images).each(function () {
      if ($(this).is(":visible")) {
        addImageZoom($(this));
      }
    })

    $('.product-thumbnail-button').click(function(e) {
      const images = $('.product-single__photos .image-container img');

      $(images).each(function () {
        if ($(this).is(":visible")) {
          removeImageZoom($(this));
        }
      })

      $(images).each(function () {
        if ($(this).is(":visible")) {
          addImageZoom($(this));
        }
      })
    })
  }
});

function addImageZoom(image){
  let url = image.data('src-full');
  let extra_class = image.hasClass("show_secondary_image") ? "img-zoom-wrapper-secondary" : "";
  image
  .wrap('<span class="img-zoom-wrapper '+ extra_class +'" style="display:inline-block"></span>')
  .css('display', 'block')
  .parent()
  .zoom({url: url, magnify: 1.7});
}
function removeImageZoom(image){
  const parent = $(image).parent();
  
  image.trigger('zoom.destroy');
  if ($(parent).hasClass('img-zoom-wrapper')) {
    image.unwrap(".img-zoom-wrapper");
  }
}